import DataAnalyticsService from "@/service/DataAnalyticsService";

const filterItems = {
    companies: [],
    regions: [],
    seasons: [],
    cultures: [],
    dateBetween: [],
    sensors: [],
}

const initialState = {
    analyticsDataProbeList: [],
    analyticsTableOptions: null,
    dropdownItems: {...filterItems},
    filterProbes: null,
    selectedProbes: [],
    analyticsDataTable: [],
    tableOptions: {},
    probesCount: 0,
    loading: false,
    recommendationTableOptions: {},
    af0Options: {},
    allDropdownItems: {...filterItems},
    recommendations: [],
    recommendationsCount: 0,
    af0: [],
    af0Count: 0
}

export default {
    namespaced: true,
    state: {...initialState},
    actions: {
        async fetchDataAnalyticsFilterObjects({commit}) {
            try {
                let resp = await DataAnalyticsService.getFilterObjects()
                if (resp.status === 200) {
                    await commit('setAllDropdownItems', resp?.data)
                    await commit('setDataAnalyticsList', resp?.data?.probes)
                }
            } catch (e) {
                console.log(e)
            }
        },
        async fetchDataAnalyticsList({commit, state}) {
            try {
                let params = {
                    company: state?.filterProbes?.company?.length > 0 ? state?.filterProbes?.company.join(",") : null,
                    region: state?.filterProbes?.region?.length > 0 ? state?.filterProbes?.region.join(",") : null,
                    season: state?.filterProbes?.season?.length > 0 ? state?.filterProbes?.season.join(",") : null,
                    culture: state?.filterProbes?.culture?.length > 0 ? state?.filterProbes?.culture.join(",") : null,
                    dates: state?.filterProbes?.dateBetween?.length > 0 ? state?.filterProbes?.dateBetween.join(",") : null,
                    sensors: state?.filterProbes?.sensor?.length > 0 ? state?.filterProbes?.sensor.join(",") : null,
                };
                let resp = await DataAnalyticsService.getFilter(params)
                if (resp.status === 200) {
                    commit('setDataAnalyticsList', resp?.data?.probes)
                    commit('setFilterItems', resp?.data)
                }
            } catch (e) {
                console.log(e)
            }
        },
        // eslint-disable-next-line no-empty-pattern
        async generateCsvFile({}, payload) {
            try {
                await DataAnalyticsService.generateCsv(payload)
            } catch (e) {
                console.log(e)
            }
        },
        async getAnalyticsRecommendationDataTableData({commit, state}) {
            try {
                let params = {
                    page: state?.recommendationTableOptions?.page ? state?.recommendationTableOptions?.page : 1,
                    itemsPerPage: state?.recommendationTableOptions?.itemsPerPage ? state?.recommendationTableOptions?.itemsPerPage : 10,
                    type: 'recommendation'
                };
                commit('setLoading', true)
                let resp = await DataAnalyticsService.getCsvRows(params)

                if (resp.status === 200) {
                    commit('setRecommendations', resp?.data?.probes)
                    commit('setRecommendationsCount', resp?.data?.probes_count)
                }
                commit('setLoading', false)
            } catch (e) {
                console.log(e)
                commit('setLoading', false)
            }
        },
        async getAnalyticsAf0DataTableData({commit, state}) {
            try {
                let params = {
                    page: state?.af0TableOptions?.page ? state?.af0TableOptions?.page : 1,
                    itemsPerPage: state?.af0TableOptions?.itemsPerPage ? state?.af0TableOptions?.itemsPerPage : 10,
                    type: 'af0'
                };
                commit('setLoading', true)
                let resp = await DataAnalyticsService.getCsvRows(params)

                if (resp.status === 200) {
                    commit('setAf0', resp?.data?.probes)
                    commit('setAf0Count', resp?.data?.probes_count)
                }
                commit('setLoading', false)
            } catch (e) {
                console.log(e)
                commit('setLoading', false)
            }
        },
        async getAnalyticsDataTableData({commit, state}) {
            try {
                let params = {
                    page: state?.tableOptions?.page ? state?.tableOptions?.page : 1,
                    itemsPerPage: state?.tableOptions?.itemsPerPage ? state?.tableOptions?.itemsPerPage : 5,
                    type: 'probe'
                };
                commit('setLoading', true)
                let resp = await DataAnalyticsService.getCsvRows(params)

                if (resp.status === 200) {
                    commit('setAnalyticsDataTable', resp?.data?.probes)
                    commit('setAnalyticsDataTableCount', resp?.data?.probes_count)
                }
                commit('setLoading', false)
            } catch (e) {
                console.log(e)
                commit('setLoading', false)
            }
        },
        // eslint-disable-next-line no-empty-pattern
        async downloadCsvFile({}, rowId) {
            try {
                let resp = await DataAnalyticsService.getCsvFile(rowId)
                if (resp.status === 200) {
                    return resp.data
                }
            } catch (e) {
                console.log(e)
            }
            return null
        }
    },
    mutations: {
        setDataAnalyticsList(state, data) {
            state.analyticsDataProbeList = data
        },
        setAnalyticsFilter(state, data) {
            state.filterProbes = {...data}
            this.dispatch("analytics/fetchDataAnalyticsList");
        },
        setFilterItems(state, data) {
            if (!data) return
            let regionNames = []
            let seasonIds = []
            let cultureIds = []
            let companiesIds = []
            let sensorIds = []

            data.probes.forEach(p => p.analytics_locations.forEach(c => {
                if (!regionNames.includes(c.region)) {
                    regionNames.push(c.region)
                }
                if (!seasonIds.includes(c.season_id)) {
                    seasonIds.push(c.season_id)
                }
                if (!cultureIds.includes(c.culture_id)) {
                    cultureIds.push(c.culture_id)
                }
                if (!companiesIds.includes(c.location_company_id)) {
                    companiesIds.push(c.location_company_id)
                }
                if (c.sensor_list) {
                    c.sensor_list.forEach(sl => {
                        if (!sensorIds.includes(sl)) {
                            sensorIds.push(sl)
                        }
                    })
                }

            }))
            let regions = state.allDropdownItems.regions
            if (regionNames.length > 0) {
                regions = state.allDropdownItems.regions.filter(r => regionNames.includes(r))
            }

            let seasons = state.allDropdownItems.seasons
            if (regionNames.length > 0) {
                seasons = state.allDropdownItems.seasons.filter(r => seasonIds.includes(r.id))
            }
            let culture = state.allDropdownItems.cultures
            if (regionNames.length > 0) {
                culture = state.allDropdownItems.cultures.filter(r => cultureIds.includes(r.culture_id))
            }

            let company = state.allDropdownItems.companies
            if (regionNames.length > 0) {
                company = state.allDropdownItems.companies.filter(r => companiesIds.includes(r.id))
            }

            let sensors = state.allDropdownItems.sensors
            if (sensorIds.length > 0) {
                sensors = state.allDropdownItems.sensors.filter(s => sensorIds.includes(s))
            }
            let data_items = {
                'companies': company,
                'regions': regions,
                'seasons': seasons,
                'cultures': culture,
                'sensors': sensors,
            }
            state.dropdownItems = {...data_items}
        },
        setAnalyticsDataTable(state, data) {
            state.analyticsDataTable = data
        },
        setAnalyticsDataTableCount(state, value) {
            state.probesCount = value
        },
        setRecommendations(state, data) {
            state.recommendations = data
        },
        setRecommendationsCount(state, value) {
            state.recommendationsCount = value
        },
        setAf0(state, data) {
            state.af0 = data
        },
        setAf0Count(state, value) {
            state.af0Count = value
        },
        setTableOptions(state, data) {
            state.tableOptions = data
            this.dispatch("analytics/getAnalyticsDataTableData");
        },
        setRecommendationTableOptions(state, data) {
            state.recommendationTableOptions = data
            this.dispatch("analytics/getAnalyticsRecommendationDataTableData");
        },
        setAf0TableOptions(state, data) {
            state.af0TableOptions = data
            this.dispatch("analytics/getAnalyticsAf0DataTableData");
        },
        setLoading(state, bool) {
            state.loading = bool
        },
        setAllDropdownItems(state, data){
            state.allDropdownItems = {...data}
            state.dropdownItems = {...data}
        }
    }
}